class PaginationTheme extends HTMLElement {
  constructor() {
    super();

    this.progress = this.querySelector(".pagination-progress");
    this.button = this.querySelector(".load-more");
    this.grid = document.getElementById("product-grid")
    
    this.total_page = this.dataset.totalPage;    
    this.i = this.dataset.currentPage ? parseInt(this.dataset.currentPage) : 1;
    this.current_page = this.dataset.currentPage ? parseInt(this.dataset.currentPage) : 1;
    
    this.renderProductCount();
    this.loadMore()
    
  }

  renderProductCount(){
    const productCards = document.querySelectorAll("#ProductGridContainer product-card");
    this.progress.querySelector(".num").innerText = productCards.length;
    this.progress.style.setProperty("--current-progress", productCards.length * 100.0/this.progress.dataset.totalNum+"%");

    if(productCards.length == this.progress.dataset.totalNum){
      this.classList.add("no-more")
    }
  }

  addUrlParam(search, key) {
      var newParam = key + '=' + this.dataset.currentPage,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }
      this.current_page = newParam;
      return params;
    }
  loadProducts() {
    if (this.getAttribute('loading')) {
      return;
    }
    this.i = parseInt(this.dataset.currentPage);
    this.i++;
    this.dataset.currentPage = this.i;
    let url = document.location.pathname + this.addUrlParam(document.location.search, 'page');
    // history.pushState({ "page": this.dataset.currentPage }, '', `${url}`);
    // if(document.querySelector(".cust-facets input[name='page']")){
    //   document.querySelector(".cust-facets input[name='page']").value = this.dataset.currentPage
    // }
    this.setAttribute('loading', true);
    
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        this.renderProducts(html, url);
      });
  }

  renderProducts(html, url) {

    const grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    this.grid.insertAdjacentHTML('beforeend', grid_to_replace.innerHTML);
    
    this.renderProductCount();
    this.removeAttribute('loading');
    klaviyoBIS?klaviyoBIS.init():'';
  }
  loadMore() {
      this.button.addEventListener('click', () => {
        this.loadProducts();
        this.blur();
        return false;
      });
    }
  
  initEventListener() {
    
  }

}

customElements.define('pagination-theme', PaginationTheme);